import { ExternalLink, X } from 'lucide-react';
import { APPROVED_SOURCES } from '../data/graph';
import { tr } from '../i18n';
import { useDiagramStore } from '../state/store';

export function SourcesModal() {
  const state = useDiagramStore();
  if (!state.sourcesOpen) return null;
  const levels = [
    ['publiclyReferenced', 'publicExplanation', 'publicly-referenced'],
    ['recommended', 'recommendedExplanation', 'recommended'],
    ['optionalExample', 'optionalExplanation', 'optional-example'],
  ] as const;
  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) state.setSourcesOpen(false); }}>
      <section className="sources-modal" role="dialog" aria-modal="true" aria-labelledby="sources-title">
        <header><div><span className="eyebrow">EVIDENCE CONTROL · MODEL SCOPE</span><h2 id="sources-title">{tr(state.language, 'modalTitle')}</h2></div><button className="icon-button" onClick={() => state.setSourcesOpen(false)} aria-label={tr(state.language, 'close')}><X size={18} /></button></header>
        <p>{tr(state.language, 'sourceIntro')}</p>
        <div className="confidence-explainer">
          {levels.map(([label, explanation, level]) => <article key={level}><span className={`confidence-dot confidence-dot--${level}`} /><div><h3>{tr(state.language, label)}</h3><p>{tr(state.language, explanation)}</p></div></article>)}
        </div>
        <h3>{tr(state.language, 'publicSources')}</h3>
        <ol className="source-links">
          <li><a href={APPROVED_SOURCES[0]} target="_blank" rel="noreferrer">Digital Marketing Manager vacancy <ExternalLink size={13} /></a></li>
          <li><a href={APPROVED_SOURCES[1]} target="_blank" rel="noreferrer">E-Commerce Business Director vacancy <ExternalLink size={13} /></a></li>
          <li><a href={APPROVED_SOURCES[2]} target="_blank" rel="noreferrer">Sinteks Careers <ExternalLink size={13} /></a></li>
        </ol>
        <p className="disclaimer-card">{tr(state.language, 'disclaimer')}</p>
        <small>{tr(state.language, 'keyboard')}</small>
      </section>
    </div>
  );
}
